import {
  observable,
  action
} from 'mobx';
import base from '../../tool/base';
import {
  message
} from 'antd';
import {
  InitStore
} from "../init/InitStore";
import util from '../../util/index';
const {
  getAccessToken,
  catchApiError,
} = util;
export class CollectStore {
  @observable appDatas = [];
  @observable whereDatas = [];
  @observable whereType = "";
  @observable current = 1;
  @observable pageSize = 10;
  @observable routes = [];
  @observable selectedRows = [];
  @observable selected = false; //页面Table全选
  @observable loading = false;
  @observable searchValue = {
    application: '',
    category: '-1'
  };
  @observable params = {
    searchValue: '',
    current: 1,
    count: 0,
    pageSize: 10,
    access_token: '',
    kind: 1,
    collect: 0,
    total: 0,
    offset: 0,
  };
  @observable addModal = {
    addWhere: "0",
    visible: false,
    title: "",
    datas: [], //存放添加项目数据，项目数据或方案数据
    cloumns: []
  }
  @observable applyModal = {
    visible: false,
    title: "申请表单"
  }
  @observable leftMenu = "proj";
  @observable projSearchData = {
    projName: "",
    proj: "",
    type: "",
    appName: ""
  }
  @observable schemeSearchData = {
    schemeName: "",
    scheme: "",
    type: "",
    appName: ""
  }
  @observable searchData = {
    whereName: "",
    wherekey: "",
    type: "",
    appName: ""
  }

  constructor(routing) {
    this.routing = routing;
    this.getRoutes = this.getRoutes.bind(this);
    this.setPage = this.setPage.bind(this);
    this.callMyAppData = this.callMyAppData.bind(this);
  }

  @action
  callMyAppData(param = {}) {
    let id = param.id;
    let kv = id === 'all' ?
      "-1" :
      id === 'workflow' ?
      "1" :
      id === 'portal' ?
      "2" :
      "-1";
    param.offset = (param.current - 1) * param.pageSize;
    this.params = {
      ...this.params,
      ...param,
      kind: kv,
      access_token: getAccessToken(),
    };
    this.loading = true;
    return new Promise((resolve) => {
      base.callApi('/v1/appCon', 'GET', this.params, 'json', 'text').then((data) => catchApiError(data, this.routing)).then((data) => {
        //1、获取顶部导航
        if (data.status) {
          this.appDatas = data.apps;
          this.params.total = data.count;
        } else {
          message.info(data.msg);
          localStorage.removeItem('me');
          InitStore.me = {};
        }
        this.loading = false;
        resolve(data);
      });
    });
  }
  getRoutes(params) {
    this.routes = [{
      key: '1',
      breadcrumbName: '云商店',
      path: '/'
    }];
    if (params.id && params.id === 'all') {
      this.routes.push({
        key: '2',
        breadcrumbName: '全部应用',
        path: '/app/list'
      });
    } else if (params.id && params.id === 'workflow') {
      this.routes.push({
        key: '2',
        breadcrumbName: '流程表单',
        path: '/app/list'
      });
    } else if (params.id && params.id === 'portal') {
      this.routes.push({
        key: '2',
        breadcrumbName: '门户应用',
        path: '/app/list'
      });
    }
    this.routes.push({
      key: '3',
      breadcrumbName: '我的收藏',
      path: '/app/collect'
    });
  }

  setPage(current, pageSize) {
    this.params.current = current;
    this.params.pageSize = pageSize;
  }

  callRemove(param, query, type) {
    let params = {
      collect: 1,
      access_token: getAccessToken(),
      ...param,
    };
    base.callApi('/v3/appcollect/edit4batch', 'POST', params, 'json', 'text').then(data => catchApiError(data, this.routing)).then((data) => {
      if (data.status === 'true') {
        message.success("移除成功");
        this.callMyAppData(query);
        this.selectedRows = [];
        this.selected = false;
      } else {
        message.success(data.msg ? data.msg : '移除失败，请重试！');
      }
    });
  }



  callMyWhereData(leftMenuParams) {
    this.searchData = {
      ...this.searchData,
      whereName: "",
      wherekey: ""
    };
    this.leftMenu = leftMenuParams;
    console.log("------searchData:", this.searchData);
    setTimeout(() => {
      this.whereDatas = require("../../mocks/datas_where_" + leftMenuParams + ".json");
    }, 300);
  }

  callAddWhereData(params, filter) {
    let where = "";
    if (params === "2") {
      this.addModal = {
        ...this.addModal,
        addWhere: "2",
        title: "项目",
        cloumns: [{
          title: '项目名称',
          dataIndex: 'name',
        }, {
          title: '项目类别',
          dataIndex: 'type',
        }]
      }
      where = "proj";
    } else if (params === "3") {
      this.addModal = {
        ...this.addModal,
        addWhere: "3",
        title: "方案",
        cloumns: [{
          title: '方案名称',
          dataIndex: 'name',
        }]
      }
      where = "scheme";
    }
    setTimeout(() => {
      this.addModal = {
        ...this.addModal,
        datas: require("../../mocks/datas_where_" + where + ".json")
      };
      if (filter && filter !== "") {
        let temp = [];
        this.addModal.datas.filter(function (el) {
          if (el && el.name.indexOf(filter) >= 0) {
            console.log("el1:", el);
            temp.push(el);
          }
        });
        this.addModal = {
          ...this.addModal,
          datas: temp
        };
      }
      this.addModal = {
        ...this.addModal,
        visible: true
      };
    }, 300);
  }

  callToAddAPP(app, where) {
    //??todo:添加应用到相应选择
    console.log("----callToAddAPP", app, where);
  }


}


// WEBPACK FOOTER //
// ./src/stores/collect/CollectStore.js